import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  moreIcon: {
    color: theme.palette.brand.greenDark,
  },
  menu: {
    padding: 0,
    marginLeft: theme.spacing(2),
    '& .MuiList-padding': { padding: '0px !important' },
    '& .MuiPaper-root': {
      borderRadius: theme.spacing(1.5),
      minWidth: '170px',
    },
  },
  menuItem: {
    borderBottom: '1px solid ' + theme.palette.custom.actions,
    display: 'flex',
    width: '100%',
    minWidth: 125,
  },
  menuItemContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  icon: {
    color: theme.palette.custom.actions,
    marginRight: theme.spacing(1),
  },
  text: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
}));

export default function KababMenuHorizontal({
  actions,
  setAnchorOpened = undefined,
  setSelectedLine = undefined,
  disabled = false,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    if (setAnchorOpened) {
      setAnchorOpened(true);
      setSelectedLine(true);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (setAnchorOpened) {
      setAnchorOpened(false);
      setSelectedLine(false);
    }
  };

  return (
    <>
      <IconButton
        aria-label="kabab_menu"
        onClick={handleClick}
        className={classes.moreIcon}
        size="small"
        disabled={disabled}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        className={classes.menu}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {actions?.map((action, i) => {
          return (
            <MenuItem
              key={i}
              selected={action.name === 'Edit'}
              onClick={handleClose}
              className={classes.menuItem}
              component={'button'}
            >
              <div className={classes.menuItemContent} onClick={action.onClick}>
                <img src={action.icon} className={classes.icon} alt="action" />
                <Typography
                  variant="subtitle1"
                  style={{ color: action.color }}
                  className={classes.text}
                >
                  {action.name}
                </Typography>
              </div>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
